import React from 'react'

import type { BreadcrumbItem } from '@/utilities/breadcrumbs'

import styles from './Breadcrumbs.module.scss'

type Props = {
  breadcrumbs: BreadcrumbItem[]
}

export const Breadcrumbs: React.FC<Props> = ({ breadcrumbs }) => {
  const previousItems = breadcrumbs.slice(0, breadcrumbs.length - 1)
  const currentItem = breadcrumbs[breadcrumbs.length - 1]

  return (
    <div className={`${styles.container} type-label`}>
      {previousItems?.map(({ label, href }) => (
        <React.Fragment key={`breadcrumb_${label}`}>
          {href ? (
            <a className="link link-reverse" href={href}>
              {label}
            </a>
          ) : (
            <span>{label}</span>
          )}
          <span>/</span>
        </React.Fragment>
      ))}
      {currentItem && <span>{currentItem.label}</span>}
    </div>
  )
}
